// This icon file is generated automatically.
var PDoubleRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M6.33 5.7L2.34.6a.25.25 0 00-.2-.1H.95C.84.5.77.62.84.7L4.99 6 .84 11.3c-.07.08 0 .2.1.2h1.2c.08 0 .16-.04.2-.1l4-5.1a.5.5 0 000-.6zm4.75 0L7.1.6a.25.25 0 00-.2-.1H5.7c-.1 0-.17.12-.1.2L9.74 6l-4.15 5.3c-.06.08 0 .2.1.2h1.2c.08 0 .16-.04.2-.1l4-5.1a.5.5 0 000-.6z", "fill-rule": "nonzero" } }] }, "name": "p-double-right", "theme": "outlined" };
export default PDoubleRightOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PDoubleRightOutlined.js
// module id = 3343
// module chunks = 0